import {Box} from '@mui/material';
import CircularShape from './circularShape';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

export default ({height, hideCircle, sx}: any) => {
  const isLarge = useIsLargeDevice();
  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        position: 'absolute',
        height: height ?? '120px',
        width: '100%',
        background: `linear-gradient(90deg, #225448 0%, #7E9F67 100%)`,
        ...sx,
      }}
    >
      {!hideCircle && (
        <>
          <Box
            sx={{
              opacity: 0.05,
              position: 'absolute',
              left: isLarge ? '133px' : '75%',
              top: isLarge ? '-49px' : '-60px',
            }}
          >
            <CircularShape size={78} />
          </Box>
          <Box
            sx={{
              opacity: 0.04,
              position: 'absolute',
              left: isLarge ? '-20px' : '-20px',
              bottom: '-30px',
            }}
          >
            <CircularShape size={66} />
          </Box>
        </>
      )}
    </Box>
  );
};
